import { makeAutoObservable } from "mobx";

export class DialogConfirmacionStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  modalRef
  showModal = false;
  messageTitle = ''
  messageInfo = ''
  promesa
  response = null

  mostrarAlerta = (titulo, message) => {
    this.messageTitle = titulo;
    this.messageInfo = message;
    this.showModal = true;
    this.response = null;
    this.promesa = (response) => { return Promise.resolve(response) }
    /*new Promise((resolve) => {
      if (this.response != null) {
        resolve(this.response)
      }
    });*/
    return this.promesa;
  };

  cerrarAlerta = () => {
    this.showModal = false
    this.response = false
    this.promesa(false)
  }

  aceptarAlerta = () => {
    this.showModal = false
    this.response = true
    this.promesa(true)
    //this.promesa.Promise.resolve(true)
    this.promesa.resolve(true)
  }

  setActionCallback = (valor) => {
    return valor
  }
}
